export default {
  sm: `
  When the foundation of value-added
  telecommunications services collapses, the
  overall economy and social activities can
  be paralyzed.
   With designs for data loss, such as
  backups and disaster recovery (DR), we
  minimize the impact of any eventuality and
  respond to ensure a quick recovery.
  We also keep our data robust and secure in
  the face of disasters and catastrophes
  outside the data center.
  `,
  md: `
  When the foundation of value-added
  telecommunications services collapses, the
  overall economy and social activities can be
  paralyzed. With designs for data loss, such
  as backups and disaster recovery (DR), we
  minimize the impact of any eventuality and
  respond to ensure a quick recovery. We also
  keep our data robust and secure in the face
  of disasters and catastrophes outside the
  data center.
  `,
  lg: `
  When the foundation of value-added telecommunications services
  collapses, the overall economy and social activities can be paralyzed.
   With designs for data loss, such as backups and disaster recovery (DR),
  we minimize the impact of any eventuality and respond to ensure a
  quick recovery. We also keep our data robust and secure in the face of
  disasters and catastrophes outside the data center.
  `,
  xxl: `
  When the foundation of value-added telecommunications services collapses, the overall
  economy and social activities can be paralyzed. With designs for data loss, such as
  backups and disaster recovery (DR), we minimize the impact of any eventuality and
  respond to ensure a quick recovery. We also keep our data robust and secure in the face
  of disasters and catastrophes outside the data center.
  `,
};  